const isDevelopmentMode = localStorage.getItem("InShopAccess")

export const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

export const isInShopAccessible = isDevelopmentMode || isMobileDevice
